import React, { useRef, useState } from 'react';
import VideoRecorderActions from './VideoRecorderActions';
import useRecorder from './useRecorder';

import { RecordingHeaderWithRouteGuard } from './RecordingHeaderWithRouteGuard';

/* import { VirtualBackgroundsButton } from './VirtualBackgroundsButton'; */
import { RECORDING_STATUS } from './types';
import { RecorderBody } from './RecorderBody';
import { VirtualBackgroundsButton } from './VirtualBackgroundsButton';
import { RecordCamLoader } from '../../components/record/RecordCamLoader';
import { VideoPreviewReply } from './VideoPreviewReply';
import { IPlayerDesign } from 'queries/videoReply/types';

interface ScreenRecorderProps {
  screenStream: MediaStream;
  stopAllStreams: () => void;
  handleGoToRecordHome: () => void;
  showPreview?: boolean;
  onStartUpladingVoiceOverHandler?: (blob: Blob) => void;
  playerDesign: IPlayerDesign | undefined;
}

export const RecordCam = ({
  screenStream,
  stopAllStreams,
  handleGoToRecordHome,
  showPreview = true,
  onStartUpladingVoiceOverHandler,
  playerDesign,
}: ScreenRecorderProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  // virtual background state
  const [showVirtualBackgrounds, setShowVirtualBackgrounds] = useState(false);
  const [isSegmenterActive, setIsSegmenterActive] = useState(false);

  const {
    stopRecording,
    pauseRecording,
    startCountDown,
    stopCountDown,
    status,
    recordedBlob,
    countdown,
    timeInSeconds,
  } = useRecorder({
    isSegmenterActive,
    canvasRef,
    videoRef,
    screenStream,
    stopAllStreams,
    onStartUpladingVoiceOverHandler,
    shouldStartCountdown: false,
    handleGoToRecordHome,
  });

  if (status === RECORDING_STATUS.DONE && recordedBlob && showPreview) {
    return (
      <VideoPreviewReply
        videoBlob={recordedBlob}
        handleGoToRecordHome={() => {
          handleGoToRecordHome();
        }}
        playerDesign={playerDesign}
      />
    );
  }

  return (
    <>
      <RecordingHeaderWithRouteGuard
        status={status}
        handleGoToRecordHome={() => {
          handleGoToRecordHome();
        }}
      />

      <div style={{ position: 'relative' }}>
        {status === RECORDING_STATUS.IDLE && (
          <RecordCamLoader text='Loading camera' />
        )}
        <RecorderBody
          videoRef={videoRef}
          canvasRef={canvasRef}
          countdown={countdown}
          status={status}
        />
        <VirtualBackgroundsButton
          videoRef={videoRef}
          canvasRef={canvasRef}
          isSegmenterActive={isSegmenterActive}
          setIsSegmenterActive={setIsSegmenterActive}
          status={status}
          showVirtualBackgrounds={showVirtualBackgrounds}
          setShowVirtualBackgrounds={setShowVirtualBackgrounds}
        />
      </div>
      <VideoRecorderActions
        startCountDown={startCountDown}
        stopCountDown={stopCountDown}
        pauseRecording={pauseRecording}
        stopRecording={stopRecording}
        status={status}
        timeInSeconds={timeInSeconds}
        showVirtualBackgrounds={showVirtualBackgrounds}
      />
    </>
  );
};
